import { useState } from 'react'
import { Typography, Stack, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ApolloError } from '@apollo/client'
import { toast } from 'components/global/CUK/Toast/Toast'

import LoginButton from '../../components/LoginButton'
import useActions from '../../../use-actions'
import { getGraphQLErrorCode } from '../LoginPage/errorHandler'


const Disclaimer: React.FC<{onCancel: () => void, onSubmit: () => void}> = ({onCancel, onSubmit}) => {
  const [loading, setLoading] = useState<boolean>(false)
  const theme = useTheme()
  const {t} = useTranslation()
  const { twoFaSendCode } = useActions()
  const hasUserId = Boolean(localStorage.getItem('TWO_FA_USER_ID')?.length)
  const handleResendCode = async ():Promise<void> => {
    setLoading(true)
    const {errors} = await twoFaSendCode()
    if (errors) {
      const isTooManyRequests = getGraphQLErrorCode(errors as ApolloError) === 'TOO_MANY_REQUESTS'
      toast.error(t(isTooManyRequests ? 'login.error.too_many_requests' : 'ui_elements.an_error_has_occurred'))
    } else {
      toast.success(t('two_fa_send_code.toast_resend'))
      onSubmit()
    }
    setLoading(false)

  }

  return (
    <Stack gap={2} sx={{ alignItems: 'center', maxWidth: '400px', color: '#656565' }}>
      <Typography
        component={'h4'}
        sx={{
          fontSize: 24,
          fontWeight: '600'
      }}
      >
        {t('two_fa_disclaimer.title')}
      </Typography>
      <Stack flex={1} sx={{textAlign: 'center', fontSize: 14}}>
        <Typography sx={{fontSize: 14}} dangerouslySetInnerHTML={{ __html: t('two_fa_disclaimer.body')}} />
      </Stack>
      {
        hasUserId
          ? (
            <LoginButton onClick={handleResendCode} disabled={loading}>
              {t('two_fa_disclaimer.button_send_code')}
            </LoginButton>
          )
          : <Typography color={'error'} sx={{fontSize: 10, fontWeight: 500}}>{t('two_fa_errors.user_id')}</Typography>
      }
      <Stack direction={'row'} gap={1}>
        <Typography sx={{fontSize: 14}} component={'span'}>{t('two_fa_disclaimer.cancel_1')}</Typography>
        <Typography
          sx={{
            fontSize: 14,
            color: theme.palette.primary.main,
            cursor: 'pointer'}}
          component={'span'}
          onClick={onCancel}
        >
          {t('two_fa_disclaimer.cancel_2')}
        </Typography>
      </Stack>
    </Stack>
  )
}

export default Disclaimer